import { OutstandingSuggestion } from 'concepts/AutoDocExtraction/outstandingSuggestions';
import { OutstandingSuggestionsModalStep } from 'concepts/AutoDocExtraction/outstandingSuggestionsTracking';
import {
  DE2FieldRenderedTrackingData,
  DE2ModalTrackingContext,
  DE2SuggestionTrackingData,
  SuggestionDecision,
  SuggestionTrigger,
  trackFieldRendered as trackFieldRenderedShared,
  trackingEvents as autoDocExtTrackingEvents,
  trackOutstandingSuggestionsModal as trackOutstandingSuggestionsModalShared,
  trackSuggestionDecision as trackSuggestionDecisionShared,
  trackSuggestionNotDisplayable as trackSuggestionNotDisplayableShared,
  trackSuggestionViewed as trackSuggestionViewedShared,
} from 'concepts/AutoDocExtraction/tracking';

const extractionTool = 'extraction2' as const;

export const trackingEvents = autoDocExtTrackingEvents(extractionTool);

type TrackingData = Omit<DE2SuggestionTrackingData, 'extractionTool'>;

export const trackSuggestionViewed = (data: TrackingData) =>
  trackSuggestionViewedShared({ ...data, extractionTool });

export const trackSuggestionNotDisplayable = (data: TrackingData) =>
  trackSuggestionNotDisplayableShared({ ...data, extractionTool });

export const trackSuggestionDecision = (
  status: SuggestionDecision,
  data: TrackingData & { trigger: SuggestionTrigger }
) => trackSuggestionDecisionShared(status, { ...data, extractionTool });

export const trackFieldRendered = (
  data: Omit<DE2FieldRenderedTrackingData, 'extractionTool'>
) => trackFieldRenderedShared({ ...data, extractionTool });

export const trackOutstandingSuggestionsModal = (
  step: OutstandingSuggestionsModalStep,
  outstanding: OutstandingSuggestion[],
  context: Omit<DE2ModalTrackingContext, 'extractionTool'>
) =>
  trackOutstandingSuggestionsModalShared(step, outstanding, {
    ...context,
    extractionTool,
  });
